var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    id: "icon-temperature",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.881,9.549c0.751,0.713,1.002,1.629,1.002,2.599c0,2.146-1.737,3.883-3.882,3.883c-2.137,0-3.882-1.737-3.882-3.883 c0-0.97,0.25-1.886,1.002-2.599V2.88C5.121,1.292,6.412,0,8.001,0s2.88,1.292,2.88,2.88V9.549z M10.631,12.147 c0-0.72-0.289-1.393-0.807-1.894l-0.195-0.188V2.88c0-0.9-0.728-1.628-1.628-1.628S6.373,1.98,6.373,2.88v7.185l-0.196,0.188 c-0.517,0.501-0.806,1.174-0.806,1.894c0,1.448,1.182,2.631,2.63,2.631S10.631,13.596,10.631,12.147z M9.629,12.147 c0,0.9-0.728,1.629-1.628,1.629s-1.628-0.729-1.628-1.629c0-0.673,0.501-1.26,1.002-1.502V5.51h1.252v5.135 C9.128,10.888,9.629,11.475,9.629,12.147z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/temperature.88cfe302bad246088404184cbd776fbe.svg";
export { ForwardRef as ReactComponent };